import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Drawer, Grid, IconButton, List, ListItem, ListItemIcon, Typography } from '@material-ui/core';
import { Menu as MenuIcon, Apps } from '@material-ui/icons';
import React from 'react';
import './AppDrawer.scss';

const AppDrawer = ({
    extended,
    applications,
    appIcon,
    applicationSelected,
    handleSideMenu,
    handleOnClickApplication,
    renderedDrawerContent,
    t,
}) => (
    <div className='app-toggle-drawer-container'>
        <IconButton className='app-drawer-toggle-button' onClick={(event) => handleSideMenu(event, true)}>
            <MenuIcon className="menu-icon" />
        </IconButton>
        <Drawer
            className='app-drawer-container'
            variant="persistent"
            anchor="left"
            open={extended}
        >
            <Grid
                container
                direction={'column'}
                justify="space-between"
                className='hide-scrollbar-sideMenu'
            >
                <Grid container item>
                    <Grid item xs={10}></Grid>
                    <Grid item xs={2}>
                        <IconButton onClick={(event) => handleSideMenu(event, false)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </IconButton>
                    </Grid>
                    <Grid item xs={12}>
                        <List>
                            {renderedDrawerContent || applications.map((app, index) => (
                                <ListItem
                                    button
                                    key={index}
                                    value={app.name}
                                    className='listItem selected'
                                    onClick={() => { handleOnClickApplication(app.name) }}
                                    selected={app.name === applicationSelected}
                                >
                                    <ListItemIcon className='icon'>
                                        {app.name === "common" ?
                                            <Apps
                                                className="navElement"
                                            /> :
                                            <FontAwesomeIcon icon={appIcon[app.name]} className='navElement' />}
                                    </ListItemIcon>
                                    <Typography className='navElement' style={{ fontWeight: 500, fontSize: '16px', fontFamily: 'SF Pro Display', marginRight: '10px' }}>{t(app.name + ':settings.appName')}</Typography>
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                </Grid>
                <Grid item>
                    <Typography>{process.env.APP_VERSION}</Typography>
                </Grid>
            </Grid>
        </Drawer>
    </div>
)
export default AppDrawer;
